// extracted by mini-css-extract-plugin
module.exports = {"mbLogo":"LoginConsumerEmail_mbLogo__1H2pj","mbLineBreak":"LoginConsumerEmail_mbLineBreak__WjdZC"};